import { DataVersion } from '@hakimo-ui/hakimo/types';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import { appendVersionParam } from '@hakimo-ui/hakimo/util';
import Event from './Event';
import { TIMELINE_HEIGHT, TIMELINE_V_SPACE } from './constants';
import { TimelineSource } from './types';
dayjs.extend(utc);

interface Props {
  sources: TimelineSource[];
  selected: string;
  map: (x: number) => number;
  onChangeSelected: (
    eventId: string,
    sourceId: string,
    timestamp: number
  ) => void;
  // Comes from the caller (ultimately the ?version=v3 URL param), not from
  // dataVersionOverrideAtom: this renders on the public shared-alarm route
  // where the Location Alarms v2/v3 toggle has no bearing on the alarm shown.
  dataVersion?: DataVersion;
}

export function Events(props: Props) {
  const { sources, selected, map, onChangeSelected, dataVersion } = props;

  const onEventClick =
    (eventId: string, sourceId: string, timestamp: number) =>
    (event: React.MouseEvent<SVGRectElement>) => {
      if (event.metaKey || event.ctrlKey) {
        const date = dayjs.utc(timestamp);
        const partitionKey = date.format('YYYYMM');
        const url = appendVersionParam(
          `/alarms/${eventId}?partitionKey=${partitionKey}`,
          dataVersion
        );
        window.open(url, '_blank', 'noopener,noreferrer');
      } else {
        onChangeSelected(eventId, sourceId, timestamp);
      }
    };

  return (
    <g className="timelines">
      {sources.map((source, i) => (
        <g
          key={source.id}
          className="timeline"
          transform={`translate(0, ${
            (TIMELINE_HEIGHT + TIMELINE_V_SPACE) * i
          })`}
        >
          {source.events.map((event) => {
            const {
              timespan: [s, e],
            } = event;

            const x1 = map(s);
            const x2 = map(e);
            const startTime = new Date(s).toLocaleTimeString();
            const endTime = new Date(e).toLocaleTimeString();

            return (
              <g key={event.id}>
                <title>
                  {startTime} - {endTime}
                </title>
                <Event
                  selected={selected === event.id}
                  x1={x1}
                  x2={x2}
                  onClick={onEventClick(event.id, source.id, s)}
                  colorClass={event.colorClass}
                />
              </g>
            );
          })}
        </g>
      ))}
    </g>
  );
}
